// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import MaskedInput from "../MaskedInput";
import { noop } from "../util";
import cpfUtils from "../util/cpfUtil";

function CpfInput({
  value,
  onChange,
  onValidityChange,
  name,
  errorMessage: externalHelperText,
  ...props
}) {
  const [touched, setTouched] = useState(false);
  const [error, setError] = useState(false);
  const [empty, setEmpty] = useState(true);

  const requiredMessage = "Campo obrigatório. Por favor, digite seu CPF";
  const errorMessage = "CPF inválido. Digite o seu CPF completo com 11 dígitos";
  const message = empty ? requiredMessage : errorMessage;
  const helperText = externalHelperText ?? message;

  useEffect(() => {
    const isValid = cpfUtils.isValid(value);

    setError(!!externalHelperText || !isValid);
    setEmpty(value.length === 0);
    onValidityChange(isValid);
  }, [externalHelperText, onValidityChange, value]);

  return (
    <MaskedInput
      name={name}
      value={value}
      onChange={onChange}
      onBlur={() => setTouched(true)}
      mask="999.999.999-99"
      placeholder="123.456.789-10"
      label="CPF"
      error={touched && error}
      helperText={touched && error ? helperText : ""}
      inputProps={{ inputMode: "decimal" }}
      {...props}
    />
  );
}

CpfInput.defaultProps = {
  onChange: noop,
  onValidityChange: noop,
  errorMessage: undefined,
};

CpfInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onValidityChange: PropTypes.func,
  errorMessage: PropTypes.string,
};

export default CpfInput;
